"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCallable = void 0;
/**
 * 处理 `R | (...args) => R` 类似类型
 * （ts <= 3.2 时无法依赖 typeof x === "function" 自动推导）
 */
function isCallable(target) {
    return typeof target === "function";
}
exports.isCallable = isCallable;
//# sourceMappingURL=is-callable.js.map